// src/app/layout/component/app.menu.ts
import { Component, OnDestroy } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { AppMenuitem } from './app.menuitem';

type Tier = 't0' | 't3' | 't6';

@Component({
  selector: 'app-menu',
  standalone: true,
  imports: [AppMenuitem, RouterModule],
  template: `
    <ul class="layout-menu customLayoutMenu">
      @for (item of model; track item; let i = $index) {
        @if (!item.separator) {
          <li app-menuitem [item]="item" [index]="i" [root]="true"></li>
        }
        @if (item.separator) {
          <li class="menu-separator"></li>
        }
      }
    </ul>
  `
})
export class AppMenu implements OnDestroy {
  model: MenuItem[] = [];
  private onMeReady = () => this.buildMenu();

  ngOnInit() {
    this.buildMenu();
    window.addEventListener('me-data-ready', this.onMeReady);
  }

  ngOnDestroy() {
    window.removeEventListener('me-data-ready', this.onMeReady);
  }

  private buildMenu() {
    const allowed = this.readAllowedTiers();
    const dashboardItems: MenuItem[] = [];

    if (allowed.includes('t0')) {
      dashboardItems.push({ label: 'T0 Dashboard', icon: 'pi pi-chart-bar', routerLink: ['/t0-dashboard'] });
    }

    if (allowed.includes('t3')) {
      dashboardItems.push({ label: 'Enhanced Simulator', icon: 'pi pi-chart-line', routerLink: ['/enhanced-simulator'] });
    }

    if (allowed.includes('t6')) {
      dashboardItems.push({ label: 'T6 Dashboard', icon: 'pi pi-chart-pie', routerLink: ['/t6-dashboard'] });
    }

    this.model = [
      {
        items: [
          { label: 'Home', icon: 'pi pi-home', routerLink: ['/home'] },

          ...(dashboardItems.length
            ? [
              {
                label: 'Dashboard',
                icon: 'pi pi-th-large',
                items: dashboardItems
              }
            ]
            : []),

          ...(allowed.includes('t6')
            ? [{
              label: 'Economy Analysis',
              icon: 'pi pi-building',
              routerLink: ['/economy-analysis']
            }]
            : []),
          { label: 'Trend Overview', icon: 'pi pi-chart-line', routerLink: ['/trend'] },
          { label: 'Model Navigator', icon: 'pi pi-compass', routerLink: ['/model-navigator'] },
          { label: 'File Upload', icon: 'pi pi-upload', routerLink: ['/file-upload'] }
        ]
      }
    ];
  }

  private readAllowedTiers(): Tier[] {
    try {
      const raw = sessionStorage.getItem('allowedTiersFromMe');
      const parsed = raw ? JSON.parse(raw) : [];
      const arr = Array.isArray(parsed) ? parsed : [];

      return arr
        .map((x: any) => String(x).trim().toLowerCase())
        .filter((x: string) => x === 't0' || x === 't3' || x === 't6') as Tier[];
    } catch {
      return [];
    }
  }
}